import { dayjs } from '../../support/helpers/dayjs.ts';
import { SecondaryWarningAdvisory } from '../SecondaryAdvisory.tsx';
import { ICompositeAdvisoryProperties } from './ICompositeAdvisoryProperties.ts';
import { IFRIAAdvisoryProperties } from '@autopylot-internal/tiles-client';

export const FRIAAdvisory = (props: ICompositeAdvisoryProperties<IFRIAAdvisoryProperties>) => (
    <SecondaryWarningAdvisory header="FAA Recognized Identification Area (FRIA)" advisoryType='advise'>
        <>
            <p>
                Your mission overlaps
                {props.advisories.map((a, i) => (
                    <span key={a.GLOBAL_ID}>
                        {i > 0 ? ', ' : ' '}
                        <strong>{a.title} FRIA</strong>, operational until {dayjs(a.endDate.substring(0, 10)).format('M/D/YYYY')}
                    </span>
                ))}.
                To operate without Remote ID, both the drone and the pilot must be located within the FRIA's boundaries throughout the operation.
            </p>
            <p>
                Prior to flight, the remote pilot in command must assess local airspace and any flight restrictions.
            </p>
        </>
    </SecondaryWarningAdvisory>
);
